import { RequestContextType } from "@utils/api-config/RequestContext";
import { AccountTypes } from "@utils/common";

export function mapAccountTypeToRequestContext(
	accountType: AccountTypes | null
): RequestContextType {
	if (accountType === AccountTypes.ONLINE) {
		return RequestContextType.Online;
	}
	if (accountType === AccountTypes.OFFLINE) {
		return RequestContextType.Shop;
	}
	return RequestContextType.Default;
}
